export default (props) => (
   /**
   * Icone da ferramenta de Dissolve.
   * Responsavel por iniciar operação de união sobre 
   * feições de camada
   */
   <svg
      width="25"
      height="21"
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
   >
      <path
         d="M14.331 2.02344C14.5234 1.6901 15.0046 1.6901 15.197 2.02344L21.6675 13.2307C21.86 13.564 21.6194 13.9807 21.2345 13.9807H8.29347C7.90857 13.9807 7.66801 13.564 7.86046 13.2307L14.331 2.02344Z"
         fill="#6E7A94"
         stroke="#BEC7DC"
      />
      <rect
         x="0.812988"
         y="7.69531"
         width="12.9441"
         height="12.0145"
         rx="1.5"
         fill="#6E7A94"
         stroke="#BEC7DC"
      />
      <path
         fillRule="evenodd"
         clipRule="evenodd"
         d="M14.2576 14.4729H8.29397C7.52417 14.4729 7.04305 13.6396 7.42795 12.9729L10.7636 7.19531H12.2576C13.3622 7.19531 14.2576 8.09074 14.2576 9.19531V14.4729Z"
         fill="#BEC7DC"
      />
   </svg>

);
